import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../lib/auth-context';
import { PageSpinner } from '../components/ui/spinner';
import { useLocale } from '../i18n/locale-context';
import { localePath } from '../i18n/locale-path';

export function Protected() {
  const { status } = useAuth();
  const { locale } = useLocale();

  if (status === 'loading') {
    return <PageSpinner />;
  }

  if (status === 'guest') {
    return <Navigate to={localePath('/login', locale)} replace />;
  }

  return <Outlet />;
}
